import request from '../../utils/request';

export function getUserLanguages() {
  return request('/user-languages', {
    method: 'Get',
  });
}
